import React, {Component} from 'react';


class Bookings extends Component {
  render() {
    return (

      <div className="bookings">

      </div>)
  }

}


export default Bookings;
